// extracted by mini-css-extract-plugin
export default {"mainClass":"job_mainClass__b53oa","h1":"job_h1__jBW1g","tabClass":"job_tabClass__pGh6m"};